// TODO: Maybe we want to move this component in next

import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NextFormComponent } from '@app/next/declarative-forms/components/declarative-form/next-form.component';
import { SelfCheckoutDeclarativeFormsModule } from '@app/verify/feature/forms/self-checkout-declarative-forms.module';
import { CampaignPage } from '@fmnts/api/next';
import { CustomStyleService } from '@fmnts/common/browser';
import { ValidationStrategy } from '@fmnts/declarative-forms';

export interface FormActionEvent {
  action: string;
  formComponent: NextFormComponent;
}

@Component({
  selector: 'verify-form-page',
  templateUrl: './form-page.component.html',
  standalone: true,
  imports: [SelfCheckoutDeclarativeFormsModule],
})
export class FormPageComponent implements OnInit, OnDestroy {
  @ViewChild(NextFormComponent, { static: true })
  formComponent!: NextFormComponent;

  @Input() page!: CampaignPage;
  @Input() pages!: CampaignPage[];
  @Input() style!: string;
  @Input() storeId!: string[];
  /** Array of actions that should be disabled */
  @Input() disabledActions: string[] = [];
  @Input() validationStrategy = ValidationStrategy.OnSubmit;

  @Output() action = new EventEmitter<FormActionEvent>();
  /**
   * Emits when the validation result changes.
   * Only emits when `ValidationStrategy` is set to `OnChange`.
   */
  @Output() isValidChanged = new EventEmitter<boolean>();

  constructor(private customStyleService: CustomStyleService) {}

  ngOnInit() {
    this.customStyleService.setGlobalStyle(this.style);
  }

  ngOnDestroy() {
    this.customStyleService.removeGlobalStyle();
  }

  public get formValuesStoreId(): string {
    return ['verify', ...this.storeId].join('_');
  }

  handleAction(action: string) {
    const { formComponent } = this;
    this.action.emit({ action, formComponent });
  }

  handleIsValidChanged(isValid: boolean) {
    this.isValidChanged.emit(isValid);
  }
}
